import { Guid } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { WarehouseOwnerContextOperationsResponse } from './warehouse-owner-context-operations.response';

@jsonObject
export class WarehouseOwnerCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseOwnerContextOperationsResponse)
  public readonly contextOperations!: WarehouseOwnerContextOperationsResponse;
}
